// Тънкият ред в горния край на картата с таблицата: „18 доставки · Филтри:
// Доставчик 2 ✕ · Плащане: Неплатени ✕ · Изчисти всички", вдясно — сумите.
// Филтрите живеят в заглавията на колоните; този ред казва какво е филтрирано
// и когато колоната е скрита вдясно (хоризонтално превъртане) или таблицата е
// карти. Винаги на ЕДИН ред: при много филтри опашката им се скрива, а пълният
// текст е в подсказката при посочване. Интерактивни са само ✕ и „Изчисти всички".
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import type { FilterSummaryItem } from "./useColumnFilters";

type Props = {
  // „18 доставки" — броят на показаните
  countLabel: string;
  items: FilterSummaryItem[];
  onClearAll: () => void;
  // Вдясно: сумите на показаните, превключвател на изгледа
  children?: ReactNode;
};

const itemText = (item: FilterSummaryItem) =>
  item.detail != null ? `${item.title}: ${item.detail}` : `${item.title} ${item.count ?? ""}`.trim();

export const FilterSummaryLine = ({ countLabel, items, onClearAll, children }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-x-2.5 overflow-hidden whitespace-nowrap border-b border-shade-2 px-[18px] py-[7px] text-[12.5px] leading-5 text-body">
      <span className="shrink-0">{countLabel}</span>
      {items.length > 0 && (
        <>
          <span className="shrink-0 text-faint">·</span>
          <span
            title={items.map(itemText).join(" · ")}
            className="flex min-w-0 items-center gap-x-2.5 overflow-hidden"
          >
            <span className="shrink-0 text-muted">{t("inventoryPage.cfFilters")}:</span>
            {items.map((item) => (
              <span key={item.key} className="flex shrink-0 items-center gap-1 text-ink-2">
                <span>{item.detail != null ? `${item.title}:` : item.title}</span>
                {item.detail != null ? (
                  <span className="font-medium text-ink">{item.detail}</span>
                ) : (
                  <span className="font-sheet text-[11.5px] font-semibold text-brand-deep-ink">{item.count}</span>
                )}
                <button
                  type="button"
                  onClick={item.onRemove}
                  aria-label={t("inventoryPage.cfRemove", { filter: itemText(item) })}
                  className="flex h-4 w-4 cursor-pointer items-center justify-center rounded border-none bg-transparent p-0 text-sm leading-none text-faint outline-none hover:bg-shade-2 hover:text-ink focus-visible:shadow-[0_0_0_2px_var(--color-brand-tint)]"
                >
                  ×
                </button>
              </span>
            ))}
          </span>
          <button
            type="button"
            onClick={onClearAll}
            className="shrink-0 cursor-pointer border-none bg-transparent p-0 text-[12.5px] leading-[normal] text-body underline outline-none hover:text-ink focus-visible:shadow-[0_0_0_2px_var(--color-brand-tint)]"
          >
            {t("inventoryPage.filterClearAll")}
          </button>
        </>
      )}
      <span className="min-w-2 flex-1" />
      {children && <span className="flex shrink-0 items-center gap-x-4">{children}</span>}
    </div>
  );
};

export default FilterSummaryLine;
